// @flow

import React, { Component } from 'react';
import { Questions } from '../../assets/model';

type Props = {
  onSubmit?: () => void,
  onChange: () => void,
  question: number,
  onComponentDidMount: () => void
};

type State = {
  title: string,
  name: string,
  phone: string,
  mail: string
};

class Adress extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      title: 'Herr',
      name: '',
      phone: '',
      mail: ''
    };
  }

  componentDidMount() {
    this.props.onComponentDidMount();
  }

  _handleChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });

    let answerPath = '';

    switch (name) {
      case 'title':
        answerPath = 'person.title';
        break;
      case 'name':
        answerPath = 'person.name';
        break;
      case 'phone':
        answerPath = 'person.phonenumber';
        break;
      case 'email':
        answerPath = 'person.mail';
        break;

      default:
        break;
    }

    const reduxAnswer = {
      answerPath,
      value
    };

    this.props.onChange(this.props.question, reduxAnswer);
  };

  _handleSubmit = event => {
    this.props.onSubmit();
    event.preventDefault();
  };

  render() {
    return (
      <React.Fragment>
        <div className="contactContainer">
          <div className="contactLeft">
            <form onSubmit={this._handleSubmit}>
              <div className="formContainer">
                <div className="form__row">
                  <div className="form__title">
                    <label>Anrede</label>
                    <br />
                    <select
                      value={this.state.title}
                      name="title"
                      onChange={event => {
                        this._handleChange(event);
                      }}
                    >
                      <option value="Herr">Herr</option>
                      <option value="Frau">Frau</option>
                    </select>
                    <br />
                  </div>

                  <div className="form__name">
                    <label className="form__label">Name</label>
                    <br />
                    <input
                      name="name"
                      type="text"
                      className="slider-input effect-2 form_input"
                      value={this.state.name}
                      onChange={event => {
                        this._handleChange(event);
                      }}
                    />
                    <span className="focus-border" />
                  </div>
                </div>

                <div className="form__phone">
                  <label className="form__label">Telefonnummer</label>
                  <br />
                  <input
                    name="phone"
                    type="tel"
                    className="slider-input effect-2 form_input"
                    value={this.state.phone}
                    onChange={event => {
                      this._handleChange(event);
                    }}
                  />
                  <span className="focus-border" />
                </div>

                <div className="form__mail">
                  <label className="form__label">Email</label>
                  <br />
                  <input
                    className="slider-input effect-2 form_input"
                    onChange={event => this._handleChange(event)}
                    value={this.state.email}
                    name="email"
                    type="email"
                  />
                  <span className="focus-border" />
                </div>
              </div>
            </form>
          </div>

          <div className="contactRight">recht</div>
        </div>
        <p>
          Durch das Anfordern der Immobilienbewertung stimme ich den{' '}
          <a href="https://www.immobilien-knowhow.de/datenschutz/">
            Datenschutzbestimmungen
          </a>{' '}
          zu.
          <br />
          <br />
        </p>
        <div className="bottomBar bottomBar--buttonRight">
          <div onClick={this._handleSubmit} className="button">
            Senden
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Adress;



// WEBPACK FOOTER //
// ./src/components/questions/Contact.js